import { render, staticRenderFns } from "./Authorize.vue?vue&type=template&id=5102e996&scoped=true"
import script from "./Authorize.vue?vue&type=script&lang=js"
export * from "./Authorize.vue?vue&type=script&lang=js"
import style0 from "./Authorize.vue?vue&type=style&index=0&id=5102e996&lang=scss&scoped=true"
import style1 from "./Authorize.vue?vue&type=style&index=1&id=5102e996&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5102e996",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5102e996')) {
      api.createRecord('5102e996', component.options)
    } else {
      api.reload('5102e996', component.options)
    }
    module.hot.accept("./Authorize.vue?vue&type=template&id=5102e996&scoped=true", function () {
      api.rerender('5102e996', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/data/Authorize.vue"
export default component.exports